import * as React from "react";
import {SelectInputV5} from "../../../input/select/SelectInputV5";
import {NumberInputV5} from "../../../details/datatypes/numeric/NumberInputV5";

interface IExplicitDateParamV5Props {
	readonly param: {length: number; type: string};
	onChange(value: {length: number | string; type: string}): void;
}

// "Days" | "Weeks" | "Months"

export class ExplicitDateParamV5 extends React.Component<IExplicitDateParamV5Props> {
	private get _length() {
		return this.props.param?.length || 1;
	}

	private get _type() {
		return this.props.param?.type || "Days";
	}

	private onEffect = () => {
		if (!this.props.param) {
			this.props.onChange({length: this._length, type: this._type});
		}
	};

	public override componentDidMount() {
		this.onEffect();
	}

	public override componentDidUpdate() {
		this.onEffect();
	}

	public override render() {
		const {onChange} = this.props;

		return (
			<>
				<NumberInputV5
					value={this._length}
					onChange={(value) => onChange({length: value, type: this._type})}
					decimals={0}
				/>
				<SelectInputV5
					selected={this._type}
					onChange={(value) => onChange({length: this._length, type: value})}
					options={["Days", "Weeks", "Months"]}
					searchBarMode="always on"
				/>
			</>
		);
	}
}
